'use client';

import { usePathname } from 'next/navigation';
import { Fragment } from 'react';

/**
 * Use this component to restart React State when navigation changes
 */
export const NavigationWrapper = ({ children }) => {
  const pathname = usePathname();
  return <Fragment key={pathname}>{children}</Fragment>;
};
